import React, { useState, useEffect, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import PageWrapper from "../SignupPages/PageWrapper";
import {
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { createNewPatient } from "../../services/api";
import "../SignupPages/SignupCommon.css";
import { useNavigate } from "react-router-dom";
import couponImage from "../../assets/images/couponIcon.png";
import padlockIcon from "../../assets/images/padlock.png";
import SemaglutideBottle from "../../assets/images/claya-semaglutide-vial-2.png";
import SemaglutideOrgBottle from "../../assets/images/claya-semaglutide-vial-2-og.png";
import OralSemaglutideImg from "../../assets/images/OralSemaglutideImg.png";
import OralTirzepatideImg from "../../assets/images//OralTirzepatideImg.png";
import TirezepatideBottle from "../../assets/images/claya-tirzepatide-vial-2.png";
import { validateCoupon, getStripeProducts } from "../../services/api";
import OnlineIcon from "../../assets/images/online.png";
import lockIcon from "../../assets/images/lockIcon.png";
import cvcIcon from "../../assets/images/cvcIcon.png";
import creditCardIcon from "../../assets/images/credit-card-icons.png";
import Alert from "../../assets/images/alert.png";
import TickIcon from "../../assets/images/tickSvgIcon.png";
import CouponBadgeicon from "../../assets/images/coupon-badge.png";
import HippaCompaliantIcon from "../../assets/images/hippa-compaliant.png";
import LegitScripticon from "../../assets/images/legit-script-icon.png";
import MoneyBackIcon from "../../assets/images/money-back.png";
import UsIcon from "../../assets/images/us-icon.png";
import Divider from "@mui/material/Divider";
import "./CheckoutSignupPages.css";

declare global {
  interface Window {
    EF?: {
      click: (params: {
        offer_id: string | null;
        affiliate_id?: string | null;
        sub1?: string | null;
        sub2?: string | null;
        sub3?: string | null;
        sub4?: string | null;
        sub5?: string | null;
        uid?: string | null;
        source_id?: string | null;
        transaction_id?: string | null;
      }) => void;
      conversion: (params: {
        offer_id: number;
        amount?: number;
        affiliate_id?: string;
      }) => void;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: (...args: any[]) => void;
  }
}

interface PaymentFormProps {
  totalPrice: number;
  pricingData: { unit_amount: number; id: string; product: string }[];
  couponDiscountValue: number | null;
  isCouponAppliedBox: boolean;
}

type Pricing = {
  "12-month": number;
  "3-month": number;
  "1-month": number;
};
const isProd = process.env.REACT_APP_ENV === "production";
const key = isProd
  ? "pk_live_51PsWA5GejApNyv7Xuy48c50fEyWxIqSglHCR33zJQNzXYUG4DHu4hpbRM80SVkXNrSPgimj1ioe3cVabLPjgN3bh00GkcYUa3H"
  : "pk_test_51PsWA5GejApNyv7Xdo7ye2sTXDMhrfaFsd15JKinSzBWaSR3iqAwTgEkbm9ZCPzit4RpxVotpvaPScTPiwwjG1ht00qiPluAWx";
const stripePromise = loadStripe(key);

const openSiteLock = (event: React.MouseEvent<HTMLAnchorElement>) => {
  event.preventDefault();
  window.open(
    "https://www.sitelock.com/verify.php?site=claya.com",
    "SiteLock",
    "width=600,height=600,left=160,top=170"
  );
};

const CheckoutSignupPage2 = () => {
  interface Product {
    type: string;
    active: boolean;
    recurring: {
      interval_count: number;
    };
    unit_amount: number;
    id: string;
    name: string;
    price: number;
    // etc.
  }
  interface PricingItem {
    id: string;
    unit_amount: number;
    product: string;
  }

  const [selectedType, setSelectedType] = useState<"Injectable" | "Oral">(
    () => {
      const stored = localStorage.getItem("selectedType");
      return stored === "Oral" || stored === "Injectable"
        ? stored
        : "Injectable";
    }
  );

  const [selectedMed, setSelectedMed] = useState<string>(() => {
    return localStorage.getItem("selectedMed") || "Semaglutide";
  });

  type Plan = "12-month" | "3-month" | "1-month";
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>("1-month");
  const [showCouponInput, setShowCouponInput] = useState(false); // default: arrow down
  const [isCouponAppliedBox, setIsCouponAppliedBox] = useState(false);
  const [showDiscountlabel, setShowDiscountLabel] = useState(false);
  const [wrongCoupon, setWrongCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponDiscountValue, setCouponDiscountValue] = useState<number | null>(
    0
  );
  const [skipAutoApply, setSkipAutoApply] = useState(false);
  const couponInputRef = useRef<HTMLInputElement | null>(null);
  const [loading1, setLoading1] = useState(false);

  const [isPaymentErr, setIsPaymentErr] = useState("");
  useEffect(() => {
    const selectedProductType = localStorage.getItem("selectedType");
    const selectedProductMed = localStorage.getItem("selectedMed");

    if (
      selectedProductType === "Injectable" ||
      selectedProductType === "Oral"
    ) {
      setSelectedType(selectedProductType);
    }

    if (selectedProductMed) {
      setSelectedMed(selectedProductMed);
    } else {
      // Default only if nothing stored
      setSelectedMed("Semaglutide");
    }
  }, []);
  let monthsToAdd = 0;
  if (selectedPlan === "12-month") {
    monthsToAdd = 12;
  } else if (selectedPlan === "3-month") {
    monthsToAdd = 3;
  } else if (selectedPlan === "1-month") {
    monthsToAdd = 1;
  }
  const nextChargeDate = new Date();
  nextChargeDate.setMonth(nextChargeDate.getMonth() + monthsToAdd); // Add 1 month
  // Get today's date
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + 150);

  //personal info
  const [uuidValue, setUuidValue] = useState<string>("");
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  }, []);
  const [finalAmount, setFinalAmount] = useState<number | null>(299);
  const [pricingData, setPricingData] = useState<PricingItem[]>([]); // Correct initial value
  const [defaultDiscount, setDefaultDiscount] = useState<number>(0);

  const getProducts = async () => {
    const productId = `${selectedMed.toLowerCase()}-${selectedType.toLowerCase()}`;
    setPricingData([]);
    try {
      const response = await getStripeProducts(productId);
      const default_Discount = response?.default_discount || 0;
      setDefaultDiscount(default_Discount);

      if (response?.data) {
        // Filter the data to get only products where type === true and  type === "recurring"
        let recurringProducts = response?.data?.filter(
          (product: Product) =>
            product.active === true && product.type === "recurring"
        );

        // Apply default discount only to Oral Semaglutide 336-day product
        if (selectedType === "Oral" && selectedMed === "Semaglutide") {
          recurringProducts = recurringProducts.map((product: Product) => {
            if (
              product.recurring?.interval_count === 336 &&
              product.unit_amount === 214800
            ) {
              return {
                ...product,
                unit_amount: product.unit_amount - default_Discount * 100, // subtract default discount
              };
            }
            return product;
          });
        }

        // Sorted the products based on interval_count
        const sortedProducts = recurringProducts.sort(
          (a: Product, b: Product) =>
            a.recurring?.interval_count - b.recurring?.interval_count
        );
        setPricingData(sortedProducts);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  const PricePerMonth = (value: number) => Number(value) || 0; // Convert string to number

  const getPricesStructure = (pricingData: any) =>
    ({
      "12-month": PricePerMonth(pricingData[2]?.unit_amount / 100 / 12), // Dynamic price per month
      "3-month": PricePerMonth(pricingData[1]?.unit_amount / 100 / 3),
      "1-month": PricePerMonth(pricingData[0]?.unit_amount / 100),
    } as Pricing);

  const getMedicationDetails = () => {
    return selectedMed === "Semaglutide"
      ? { name: "Semaglutide", price: getPricesStructure(pricingData) }
      : { name: "Tirzepatide", price: getPricesStructure(pricingData) };
  };

  const { name } = getMedicationDetails();
  const getPlanDetails = () => {
    const { price } = getMedicationDetails();

    let monthlyPrice: number;

    // Ensure selectedPlan is not null
    if (selectedPlan) {
      monthlyPrice = (price as Pricing)[selectedPlan]; // Cast `price` to `Pricing`
    } else {
      // Handle the case where selectedPlan is null (fallback or error)
      monthlyPrice = 0; // or some default value
    }

    let totalPrice;
    if (selectedPlan === "12-month") {
      totalPrice = monthlyPrice * 12;
    } else if (selectedPlan === "3-month") {
      totalPrice = monthlyPrice * 3;
    } else {
      totalPrice = monthlyPrice; // For 1-month plan
    }

    totalPrice = totalPrice - (couponDiscountValue || 0);

    return {
      price: totalPrice,
      monthlyPrice,
      plan: `${selectedPlan} plan`,
    };
  };

  const { price: totalPrice } = getPlanDetails();

  const defaultCouponCode = "100TestClaya";

  /** Auto-apply default coupon on load **/
  useEffect(() => {
    const autoApplyDefaultCoupon = async () => {
      if (skipAutoApply || pricingData.length === 0 || isCouponAppliedBox)
        return;
      try {
        const priceItem =
          selectedPlan === "1-month"
            ? pricingData[0]
            : selectedPlan === "3-month"
            ? pricingData[1]
            : pricingData[2];

        const productId = priceItem?.product;
        const response = await validateCoupon(
          defaultCouponCode,
          totalPrice,
          productId
        );

        if (response.valid) {
          setCouponCode(defaultCouponCode);
          setCouponDiscountValue(response.discount);
          setFinalAmount((prev) =>
            prev !== null ? prev - response.discount : null
          );
          setIsCouponAppliedBox(true);
          localStorage.setItem("promoCode", defaultCouponCode);
        }
      } catch (err) {
        console.error("Default coupon auto-apply failed:", err);
      }
    };
    autoApplyDefaultCoupon();
  }, [pricingData, selectedPlan, skipAutoApply]);

  /** Apply coupon logic **/
  const applyCoupon = async (code?: string) => {
    const codeToApply = code || couponCode.trim();
    if (!codeToApply) return;

    try {
      setLoading1(true);
      const priceItem =
        selectedPlan === "1-month"
          ? pricingData[0]
          : selectedPlan === "3-month"
          ? pricingData[1]
          : pricingData[2];
      const productId = priceItem?.product;
      const response = await validateCoupon(codeToApply, totalPrice, productId);

      if (response.valid) {
        setCouponDiscountValue(response.discount);
        setFinalAmount((prev) =>
          prev !== null ? prev - response.discount : null
        );
        setWrongCoupon(false);
        localStorage.setItem("promoCode", codeToApply);

        if (codeToApply.toUpperCase() === defaultCouponCode.toUpperCase()) {
          setIsCouponAppliedBox(true);
          setShowDiscountLabel(false);
        } else {
          setShowDiscountLabel(true);
          setIsCouponAppliedBox(false);
        }
      } else {
        setWrongCoupon(true);
      }
    } catch (error) {
      console.error("Error validating coupon:", error);
      setWrongCoupon(true);
    } finally {
      setLoading1(false);
    }
  };

  /** Remove coupon **/
  const removeCoupon = () => {
    setIsCouponAppliedBox(false);
    setShowDiscountLabel(false);
    setCouponCode("");
    setFinalAmount((prev) =>
      prev !== null ? prev + (couponDiscountValue || 0) : null
    );
    setCouponDiscountValue(0);
    localStorage.removeItem("promoCode");
    setSkipAutoApply(true);
  };

  const toggleCouponInput = () => setShowCouponInput((prev) => !prev);

  const handleCouponCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponCode(e.target.value);
    if (wrongCoupon) setWrongCoupon(false); // reset only if needed
  };

  useEffect(() => {
    if (couponInputRef.current) {
      couponInputRef.current.focus();
    }
  }, [couponCode]);
  const PaymentForm: React.FC<PaymentFormProps> = ({
    totalPrice,
    pricingData,
    couponDiscountValue,
    isCouponAppliedBox,
  }) => {
    const [addressLine1, setAddressLine1] = useState<string>("");
    const [addressLine2, setAddressLine2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [zip, setZip] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [phone, setPhone] = useState<string>("");

    const [billingAddressAddressLine1, setBillingAddressAddressLine1] =
      useState<string>("");
    const [billingAddressAddressLine2, setBillingAddressAddressLine2] =
      useState<string>("");
    const [billingAddressState, setBillingAddressState] = useState<string>("");
    const [billingAddressCity, setBillingAddressCity] = useState<string>("");
    const [billingAddressZip, setBillingAddressZip] = useState<string>("");
    const [isCardNumberValid, setIsCardNumberValid] = useState(false);
    const [isCardExpiryValid, setIsCardExpiryValid] = useState(false);
    const [isCardCvcValid, setIsCardCvcValid] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [uuid, setUuid] = useState("");
    const [stateError, setStateError] = useState("");
    const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
    const [firstNameError, setFirstNameError] = useState<string>("");
    const [lastNameError, setLastNameError] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [phoneError, setPhoneError] = useState<string>("");
    const [addressLine1Error, setAddressLine1Error] = useState<string>("");
    const [cityError, setCityError] = useState<string>("");
    const [zipError, setZipError] = useState<string>("");

    const [
      billingAddressAddressLine1Error,
      setBillingAddressAddressLine1Error,
    ] = useState<string>("");
    const [billingAddressStateError, setBillingAddressStateError] =
      useState<string>("");
    const [billingAddressCityError, setBillingAddressCityError] =
      useState<string>("");
    const [billingAddressZipError, setBillingAddressZipError] =
      useState<string>("");
    const isVariant = localStorage.getItem("isVariant") === "true";
    const [disableAddress, setDisableAddress] = useState<boolean>(false);
    const handleCheckboxChange = () => {
      setIsChecked(!isChecked);
    };
    useEffect(() => {
      const firstName = localStorage.getItem("firstName");
      const lastName = localStorage.getItem("lastName");
      const address1 = localStorage.getItem("addressLine1");
      const address2 = localStorage.getItem("addressLine2");
      const city = localStorage.getItem("city");
      const state = localStorage.getItem("state");
      const zip = localStorage.getItem("zip");
      const email = localStorage.getItem("email");
      const phone = localStorage.getItem("phone");
      const isSubscribed = localStorage.getItem("isSubscribed");
      const uuid = localStorage.getItem("uuid");

      if (address1) {
        setAddressLine1(JSON.parse(address1).value);
      }
      if (address2) {
        setAddressLine2(JSON.parse(address2).value);
      }
      if (city) {
        setCity(JSON.parse(city).value);
      }
      if (state) {
        const parsedState = JSON.parse(state).value;
        setState(parsedState);
      }
      if (zip) {
        setZip(JSON.parse(zip).value);
      }
      if (email) {
        setEmail(JSON.parse(email).value);
      }
      if (firstName) {
        setFirstName(JSON.parse(firstName).value);
      }
      if (lastName) {
        setLastName(JSON.parse(lastName).value);
      }
      if (phone) {
        setPhone(JSON.parse(phone).value);
      }
      if (isSubscribed) {
        setIsSubscribed(JSON.parse(isSubscribed).value);
      }
      if (uuid) {
        setUuid(JSON.parse(uuid).value);
      }
      // if (fullName) {
      //   setFullName(JSON.parse(fullName).value);
      // }
    }, []); // Runs once when the component mounts
    const handleCardNumberChange = (event: { complete: boolean }) => {
      setIsCardNumberValid(event.complete);
    };

    const handleCardExpiryChange = (event: { complete: boolean }) => {
      setIsCardExpiryValid(event.complete);
    };

    const handleCardCvcChange = (event: { complete: boolean }) => {
      setIsCardCvcValid(event.complete);
    };

    const isCardValid =
      isCardNumberValid && isCardExpiryValid && isCardCvcValid;

    const formatPhoneNumber = (value: string): string => {
      const cleaned = ("" + value).replace(/\D/g, "");
      if (cleaned.length > 10) {
        setPhoneError("Phone number cannot exceed 10 digits");
        return value;
      } else {
        setPhoneError("");
      }

      if (cleaned.length <= 3) {
        return `(${cleaned}`;
      } else if (cleaned.length <= 6) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      } else {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
          6,
          10
        )}`;
      }
    };

    const stateOptions = {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "District of Columbia",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UT: "Utah",
      VA: "Virginia",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming",
    };

    const everflowConversion = () => {
      // For now return as not needed on upsell load
      const script = document.createElement("script");
      const eFconversionCodeExecuted = window.localStorage.getItem(
        "EFconversionCodeExecuted"
      );
      script.src = "https://www.sffpl8trk.com/scripts/sdk/everflow.js";
      script.type = "text/javascript";
      script.async = true;
      script.onload = () => {
        if (window.EF && eFconversionCodeExecuted !== "true") {
          window.EF.conversion({
            offer_id: parseInt(localStorage.getItem("offer_id") || ""),
            affiliate_id: localStorage.getItem("affiliate_id") || "",
            amount: totalPrice ? totalPrice : undefined,
          });
          window.localStorage.setItem("EFconversionCodeExecuted", "true");
          if (typeof window.fbq === "function") {
            window.fbq("track", "Purchase", {
              currency: "USD",
              value: totalPrice,
            });
          } else {
            console.warn("Facebook Pixel (fbq) not loaded yet.");
          }
        } else {
          console.warn("Everflow SDK failed to load.");
        }
      };
      document.body.appendChild(script);
    };

    const pushPurchaseEvent = (
      itemName: string,
      medicationType: string,
      price: string,
      planSelected: string,
      transactionID: string
    ) => {
      if (localStorage.getItem("GTMPurchaseEventFired")) {
        return;
      } else {
        const key = `${itemName.toLowerCase()}-${medicationType.toLowerCase()}`;
        const itemIdMap: Record<string, number> = {
          "semaglutide-injectable": 1,
          "tirzepatide-injectable": 2,
          "semaglutide-oral": 3,
          "tirzepatide-oral": 4,
        };
      
        const itemId = itemIdMap[key];
        if (!itemId) return;
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            transaction_id: transactionID,
            value: price,
            currency: "USD",
            items: [
              {
                item_id: itemId,
                item_name: `${itemName}-${medicationType}`,
                price: price,
                quantity: 1,
                plan_selected: planSelected,
              },
            ],
          },
        });
        localStorage.setItem("GTMPurchaseEventFired", "true");
        localStorage.setItem("GTMPurchaseEventTimestamp", Date.now().toString());
      }
    };

    // Handle input change and save to localStorage
    const handleChange = (
      e: React.ChangeEvent<HTMLInputElement>,
      field: string
    ) => {
      const newValue = e.target.value;

      // Update state based on the field name
      switch (field) {
        case "firstName":
          setFirstName(newValue);
          localStorage.setItem(
            "firstName",
            JSON.stringify({ value: newValue })
          );
          if (newValue.trim() === "") {
            setFirstNameError("Please enter your first name");
          } else {
            setFirstNameError("");
          }
          break;
        case "lastName":
          setLastName(newValue);
          localStorage.setItem("lastName", JSON.stringify({ value: newValue }));
          if (newValue.trim() === "") {
            setLastNameError("Please enter your last name");
          } else {
            setLastNameError("");
          }
          break;
        case "email":
          setEmail(newValue);
          localStorage.setItem("email", JSON.stringify({ value: newValue }));
          if (
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(newValue)
          ) {
            setEmailError("Please enter a valid email");
          } else {
            setEmailError("");
          }
          break;
        case "phone":
          if (newValue.replace(/\D/g, "").length > 10) return;
          if (newValue.replace(/\D/g, "").length !== 10) {
            setPhoneError("Please enter a valid 10-digit phone number");
          } else {
            setPhone(formatPhoneNumber(newValue));
            localStorage.setItem("phone", JSON.stringify({ value: newValue }));
            setPhoneError("");
          }
          setPhone(formatPhoneNumber(newValue));
          localStorage.setItem("phone", JSON.stringify({ value: newValue }));
          break;
        case "addressLine1":
          setAddressLine1(newValue);
          localStorage.setItem(
            "addressLine1",
            JSON.stringify({ value: newValue })
          );
          if (newValue.trim() === "") {
            setAddressLine1Error("Please enter your Address Line 1");
          } else {
            setAddressLine1Error("");
          }
          break;
        case "addressLine2":
          setAddressLine2(newValue);
          localStorage.setItem(
            "addressLine2",
            JSON.stringify({ value: newValue })
          );
          break;
        case "city":
          setCity(newValue);
          localStorage.setItem("city", JSON.stringify({ value: newValue }));
          if (newValue.trim() === "") {
            setCityError("Please enter your city");
          } else {
            setCityError("");
          }
          break;
        case "state":
          if (newValue.trim() === "") {
            setStateError("Please enter your state");
            setState("");
            localStorage.setItem(
              "medicationRestrictions",
              JSON.stringify({ value: "both" })
            );
            break;
          }
          setStateError("");
          setState(newValue);
          localStorage.setItem("state", JSON.stringify({ value: newValue }));
          break;
        case "zip":
          if (newValue.length > 5) return;
          if (newValue.trim() === "") {
            setZipError("Please enter your zip code");
          } else {
            setZipError("");
          }
          setZip(newValue);
          localStorage.setItem("zip", JSON.stringify({ value: newValue }));
          break;
        case "billingAddressAddressLine1":
          setBillingAddressAddressLine1(newValue);
          localStorage.setItem(
            "billingAddressAddressLine1",
            JSON.stringify({ value: newValue })
          );
          if (newValue.trim() === "") {
            setBillingAddressAddressLine1Error(
              "Please enter your Address Line 1"
            );
          } else {
            setBillingAddressAddressLine1Error("");
          }
          break;
        case "billingAddressAddressLine2":
          setBillingAddressAddressLine2(newValue);
          localStorage.setItem(
            "billingAddressAddressLine2",
            JSON.stringify({ value: newValue })
          );
          break;
        case "billingAddressCity":
          setBillingAddressCity(newValue);
          localStorage.setItem(
            "billingAddressCity",
            JSON.stringify({ value: newValue })
          );
          if (newValue.trim() === "") {
            setBillingAddressCityError("Please enter your city");
          } else {
            setBillingAddressCityError("");
          }
          break;
        case "billingAddressState":
          setBillingAddressState(newValue);
          localStorage.setItem(
            "billingAddressState",
            JSON.stringify({ value: newValue })
          );
          if (newValue.trim() === "") {
            setBillingAddressStateError("Please enter your state");
          } else {
            setBillingAddressStateError("");
          }
          break;
        case "billingAddressZip":
          if (newValue.length > 5) return;
          if (newValue.trim() === "") {
            setBillingAddressZipError("Please enter your zip");
          } else {
            setBillingAddressZipError("");
          }
          setBillingAddressZip(newValue);
          localStorage.setItem(
            "billingAddressZip",
            JSON.stringify({ value: newValue })
          );
          break;
        default:
          break;
      }
    };

    const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const selectedState = e.target.value as keyof typeof stateOptions;

      if (selectedState.trim() === "") {
        setStateError("Please select your state");
        setState("");
        localStorage.setItem(
          "medicationRestrictions",
          JSON.stringify({ value: "both" })
        );
        return;
      }

      setStateError("");
      setState(selectedState);
      localStorage.setItem("state", JSON.stringify({ value: selectedState }));
      localStorage.setItem(
        "fullState",
        JSON.stringify({ key: "fullState", value: stateOptions[selectedState] })
      );
    };

    const handleChangeBillingState = (
      e: React.ChangeEvent<HTMLSelectElement>
    ) => {
      const selectedState = e.target.value as keyof typeof stateOptions;
      setBillingAddressState(selectedState);
      localStorage.setItem(
        "billingAddressState",
        JSON.stringify({ value: selectedState })
      );
      if (selectedState.trim() === "") {
        setBillingAddressStateError("Please select your state");
      } else {
        setBillingAddressStateError("");
      }
    };

    const stripe = useStripe();
    const elements = useElements();
    const [patientError, setPatientError] = useState<string>("");
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [country, setCountry] = useState("");
    const [postcode, setPostcode] = useState("");
    const [isCheckedTerms, setIsCheckedTerms] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
      console.log(couponCode);
      event.preventDefault();
      setLoading(true);

      if (!stripe || !elements) {
        setError("Stripe is not ready. Please refresh the page.");
        setLoading(false);
        return;
      }

      const productCategory = "GLP1";

      const URL =
        process.env.REACT_APP_ENV === "production"
          ? "https://claya-ruby-b715fff96163.herokuapp.com"
          : "https://claya-stage-ruby-03e61b6e8c6b.herokuapp.com";

      const cardNumberElement = elements.getElement(CardNumberElement);
      if (!cardNumberElement) {
        setError("Card number element not found.");
        setLoading(false);
        return;
      }

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          email: email,
          name: firstName,
        },
      });

      if (error) {
        setLoading(false);
        console.error("Payment method error:", error);
        return;
      }
      let priceId;
      let planType;
      const discount = couponDiscountValue || 0;

      //dynamically assigning price value and price id
      if (isProd) {
        if (totalPrice + discount === pricingData[0]?.unit_amount / 100) {
          priceId = pricingData[0]?.id;
          planType = "1 month";
        } else if (
          totalPrice + discount ===
          pricingData[1]?.unit_amount / 100
        ) {
          priceId = pricingData[1]?.id;
          planType = "3 month";
        } else if (
          totalPrice + discount ===
          pricingData[2]?.unit_amount / 100
        ) {
          priceId = pricingData[2]?.id;
          planType = "12 month";
        }
      } else {
        if (totalPrice + discount === pricingData[0]?.unit_amount / 100) {
          priceId = pricingData[0]?.id;
          planType = "1 month";
        } else if (
          totalPrice + discount ===
          pricingData[1]?.unit_amount / 100
        ) {
          priceId = pricingData[1]?.id;
          planType = "3 month";
        } else if (
          totalPrice + discount ===
          pricingData[2]?.unit_amount / 100
        ) {
          priceId = pricingData[2]?.id;
          planType = "12 month";
        }
      }

      localStorage.setItem("priceId", priceId || "");
      localStorage.setItem("planType", planType || "");
      localStorage.setItem("planPrice", String(totalPrice) || "");
      localStorage.setItem("itemName", selectedMed);
      localStorage.setItem("medicationType", selectedType);

      try {
        const appointmentResponse = await createNewPatient(
          firstName,
          lastName,
          email,
          phone,
          isSubscribed,
          productCategory,
          uuid
        );

        const appointmentData = await appointmentResponse.json();
        if (!appointmentResponse.ok) {
          setLoading(false);
          throw new Error(
            appointmentData?.error || "Failed to create patient."
          );
        }
      } catch (err: unknown) {
        if (err instanceof Error) {
          setLoading(false);
          setPatientError(err?.message);
        } else {
          setLoading(false);
          setPatientError("Something went wrong while creating patient");
        }
        return;
      }

      const response = await fetch(
        `${URL}/api/v1/patients/payments/create_subscription`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            first_name: firstName,
            last_name: lastName,
            payment_method_id: paymentMethod.id,
            price_id: priceId, // Replace with your actual Stripe Price ID
            product_name: `${selectedMed}-${selectedType}`,
            uuid: uuidValue,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setLoading(false);
        setIsPaymentErr(data?.error);
      }

      const { customer_id, client_secret } = data;

      if (client_secret) {
        const { error, setupIntent } = await stripe.confirmCardSetup(
          client_secret
        );

        try {
          setLoading(true);
          const UpdateAndCaptureResponse = await fetch(
            `${URL}/api/v1/patients/payments/update_and_capture_subscription`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                customer_id,
                base_price_id: priceId,
                product_name: `${selectedMed.toLowerCase()}-${selectedType.toLowerCase()}`,
                planType,
                email,
                promo_code: couponCode,
                uuid: uuidValue,
              }),
            }
          );

          const responseData = await UpdateAndCaptureResponse.json();

          if (!UpdateAndCaptureResponse.ok) {
            console.error("API Error:", responseData);
            setLoading(false);
            setIsPaymentErr(
              responseData?.error ||
                "Failed to update and capture subscription."
            );
            throw new Error(
              `Network error: ${UpdateAndCaptureResponse.status} - ${
                responseData?.error || "Unknown error"
              }`
            );
          } else {
            const transactionID = responseData["transaction_id"];
            pushPurchaseEvent(
              selectedMed,
              selectedType,
              String(totalPrice),
              String(planType),
              transactionID
            );
            everflowConversion();
            localStorage.setItem(
              "success_transaction",
              JSON.stringify({
                key: "success_transaction",
                value: responseData["success"],
              })
            );
            localStorage.setItem(
              "uuidConversion",
              JSON.stringify({ key: "uuidConversion", value: "yes" })
            );
            localStorage.setItem(
              "AmountToPay",
              JSON.stringify({ key: "AmountToPay", value: finalAmount })
            );
            localStorage.setItem("customer_id", customer_id);
          }
        } catch (error) {
          console.error("Error in update and capture subscription:", error);

          setIsPaymentErr(
            `Payment processing error: ${
              error instanceof Error ? error.message : String(error)
            }`
          );
        } finally {
          setLoading(false);
        }

        if (error) {
          console.error("Authorization failed:", error);
        } else {
          console.log("Subscription authorized!", setupIntent);
          localStorage.setItem(
            "uuidConversion",
            JSON.stringify({ key: "uuidConversion", value: "yes" })
          );
          localStorage.setItem(
            "AmountToPay",
            JSON.stringify({ key: "AmountToPay", value: finalAmount })
          );
          localStorage.setItem("customer_id", customer_id);
          navigate("/glp1/thank-you");
        }
      }
      setLoading(false);
    };

    const elementStyle = {
      style: {
        base: {
          fontSize: window.innerWidth > 600 ? "14px" : "16px",
          color: "#32325d",
        },
        invalid: { color: "#fa755a" },
      },
    };

    const inputError = (errorMessage: string) => {
      if (!errorMessage) return null;
      return (
        <div className="checkout-state-error">
          <img src={Alert} alt="state-error" width={"16px"} height={"15px"} />
          <p className="checkout-state-error-text">{errorMessage}</p>
        </div>
      );
    };

    const apiError = (errorMessage: string) => {
      if (!errorMessage) return null;
      return (
        <div
          className="checkout-state-error"
          style={{ height: "45px", margin: "10px 0px" }}
        >
          <img src={Alert} alt="state-error" width={"16px"} height={"15px"} />
          <p className="checkout-state-error-text">{errorMessage}</p>
        </div>
      );
    };

    const disbaledBtn =
      !!firstNameError ||
      !!lastNameError ||
      !!emailError ||
      !!phoneError ||
      !!addressLine1Error ||
      !!cityError ||
      !!stateError ||
      !!zipError ||
      !!billingAddressAddressLine1Error ||
      !!billingAddressCityError ||
      !!billingAddressStateError ||
      !!billingAddressZipError ||
      (!isVariant && !isSubscribed);

    const SelectedProductCard = () => {
      const medications = {
        Injectable: [
          {
            id: "Semaglutide",
            name: "Semaglutide",
            img: SemaglutideOrgBottle,
            desc: "Same active ingredient as Ozempic® and Wegovy®",
            tag: "Most Popular",
          },
          {
            id: "Tirzepatide",
            name: "Tirzepatide",
            img: TirezepatideBottle,
            desc: "Same active ingredient as Mounjaro® and Zepbound®",
            tag: "Most Effective",
          },
        ],
        Oral: [
          {
            id: "Semaglutide",
            name: "Semaglutide",
            img: OralSemaglutideImg,
            desc: "Same active ingredient as Ozempic® and Wegovy®",
            tag: "Most Popular",
          },
          {
            id: "Tirzepatide",
            name: "Tirzepatide",
            img: OralTirzepatideImg,
            desc: "Same active ingredient as Mounjaro® and Zepbound®",
            tag: "Most Effective",
          },
        ],
      };

      const selectedMedication = medications[selectedType]?.find(
        (med) => med.name === selectedMed
      );

      if (!selectedMedication) return null;

      return (
        <div className="selected-product-card-box">
          <div className="selected-product-label">Your selection</div>
          <div className="product-box">
            <img
              src={selectedMedication.img}
              alt={selectedMedication.name}
              className="product-image"
            />
            <div className="product-content-box">
              <h2 className="product-name">{selectedMedication.name}</h2>
              <p className="product-desc">{selectedMedication.desc}</p>
              <div className="product-price-stock-box">
                <div className="stock-status">
                  <img src={OnlineIcon} alt="In Stock" className="stock-icon" />
                  <span className="stock-label">In-Stock</span>
                </div>
                <div className="product-box-price">
                  <span className="product-old-price">
                    {(isCouponAppliedBox || isCouponAppliedBox) &&
                      (pricingData && pricingData[0]
                        ? `$${Math.floor(pricingData[0]?.unit_amount / 100)}`
                        : "")}
                  </span>

                  <div className="product-new-price-content">
                    <span className="product-starts-from">starts from</span>
                    <span className="product-new-price">
                      {pricingData && pricingData[0]
                        ? `$${Math.floor(
                            pricingData[0]?.unit_amount / 100 -
                              (couponDiscountValue || 0)
                          )}`
                        : ""}
                      /mo
                    </span>
                  </div>
                </div>
              </div>
              <span className="coupon-badge coupon-badge-box">
                $100 OFF 1st MONTH
              </span>
            </div>
          </div>
        </div>
      );
    };

    return (
      <form onSubmit={handleSubmit} className="checkout-container">
        <div className="checkout-med-container-box">
          {SelectedProductCard()}
        </div>
        <div className="benefits-container-box">
          <div className="benefit-box-item">
            <svg
              className="check-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                fill="#008000"
              />
            </svg>
            <span>100% Confidential & HIPAA Compliant</span>
          </div>
          <div className="benefit-box-item">
            <svg
              className="check-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                fill="#008000"
              />
            </svg>
            <span>FSA/HSA eligible for reimbursement</span>
          </div>
          <div className="benefit-box-item">
            <svg
              className="check-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                fill="#008000"
              />
            </svg>
            <span>Cancel or change your plan anytime</span>
          </div>
          <div className="benefit-box-item">
            <svg
              className="check-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                fill="#008000"
              />
            </svg>
            <span>Ships every month</span>
          </div>
          <div className="benefit-box-item">
            <svg
              className="check-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
                fill="#008000"
              />
            </svg>
            <span>Includes 1 month of medication + injection supplies</span>
          </div>
        </div>
        <div
          className="checkout-features stripe-container"
          style={{ backgroundColor: "#fff" }}
        >
          <div>
            <h2 className="stripe-checkout-font">Account Details</h2>
            <div className="account-detail-container">
              <div className="state-zip-pacement">
                <div className="input-field-placement first-name">
                  <label className="lable-font">First name</label>
                  <input
                    type="text"
                    placeholder="First Name"
                    className="field-styling"
                    required
                    value={firstName}
                    onChange={(e) => handleChange(e, "firstName")}
                  />
                </div>
                <div className="input-field-placement last-name">
                  <label className="lable-font">Last name</label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    className="field-styling"
                    required
                    value={lastName}
                    onChange={(e) => handleChange(e, "lastName")}
                  />
                </div>
              </div>
              {firstNameError && inputError(firstNameError)}
              {lastNameError && inputError(lastNameError)}
              <div className="input-field-placement">
                <label className="lable-font">Email</label>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="field-styling"
                  required
                  value={email}
                  onChange={(e) => handleChange(e, "email")}
                />
              </div>
              {emailError && inputError(emailError)}

              <div className="input-field-placement">
                <label className="lable-font">Phone</label>
                <input
                  type="tel"
                  placeholder="Phone number: (XXX) XXX-XXXX"
                  className="field-styling"
                  required
                  value={phone}
                  onChange={(e) => handleChange(e, "phone")}
                />
              </div>
              {phoneError && inputError(phoneError)}
            </div>
          </div>
          <div>
            <h2 className="stripe-checkout-font">Shipping Address</h2>
            <div className="account-detail-container">
              <div className="input-field-placement">
                <label className="lable-font">Address line 1</label>
                <input
                  type="text"
                  placeholder="Address"
                  className="field-styling"
                  style={{
                    backgroundColor: disableAddress ? "rgb(229, 237, 246)" : "",
                  }}
                  disabled={disableAddress}
                  required
                  value={addressLine1}
                  onChange={(e) => handleChange(e, "addressLine1")}
                />
              </div>
              {addressLine1Error && inputError(addressLine1Error)}
              <div className="input-field-placement">
                <label className="lable-font">Address line 2</label>
                <input
                  type="text"
                  placeholder="Address"
                  className="field-styling"
                  style={{
                    backgroundColor: disableAddress ? "rgb(229, 237, 246)" : "",
                  }}
                  disabled={disableAddress}
                  value={addressLine2}
                  onChange={(e) => handleChange(e, "addressLine2")}
                />
              </div>
              <div className="input-field-placement">
                <label className="lable-font">City</label>
                <input
                  type="text"
                  placeholder="City"
                  className="field-styling"
                  style={{
                    backgroundColor: disableAddress ? "rgb(229, 237, 246)" : "",
                  }}
                  disabled={disableAddress}
                  required
                  value={city}
                  onChange={(e) => handleChange(e, "city")}
                />
              </div>
              {cityError && inputError(cityError)}
              <div className="state-zip-pacement">
                <div className="input-field-placement">
                  <label className="lable-font">State</label>
                  <select
                    id="state"
                    name="state"
                    value={state}
                    onChange={handleStateChange}
                    className="field-styling"
                  >
                    <option value="">Select a state</option>
                    {Object.entries(stateOptions).map(
                      ([abbreviation, fullName]) => (
                        <option key={abbreviation} value={abbreviation}>
                          {fullName}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="input-field-placement">
                  <label className="lable-font">Zip</label>
                  <input
                    type="text"
                    placeholder="Zip"
                    className="field-styling"
                    style={{
                      backgroundColor: disableAddress
                        ? "rgb(229, 237, 246)"
                        : "",
                    }}
                    disabled={disableAddress}
                    required
                    value={zip}
                    onChange={(e) => handleChange(e, "zip")}
                  />
                </div>
              </div>
              {stateError && inputError(stateError)}
              {zipError && inputError(zipError)}
            </div>
          </div>
          <div>
            <h2 className="stripe-checkout-font">Billing Address</h2>
            <div className="input-field-placement-checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  className="sameAsShippingText"
                  style={{ cursor: "pointer" }}
                />
                Use a different billing address
              </label>
            </div>
            {isChecked && (
              <div className="account-detail-container">
                <div className="input-field-placement">
                  <label className="lable-font">Address line 1</label>
                  <input
                    type="text"
                    placeholder="Address"
                    className="field-styling"
                    required
                    value={
                      !isChecked ? addressLine1 : billingAddressAddressLine1
                    }
                    onChange={(e) =>
                      handleChange(e, "billingAddressAddressLine1")
                    }
                  />
                </div>
                {billingAddressAddressLine1Error &&
                  inputError(billingAddressAddressLine1Error)}
                <div className="input-field-placement">
                  <label className="lable-font">Address line 2</label>
                  <input
                    type="text"
                    placeholder="Address"
                    className="field-styling"
                    value={
                      !isChecked
                        ? `${addressLine2}`
                        : `${billingAddressAddressLine2}`
                    }
                    onChange={(e) =>
                      handleChange(e, "billingAddressAddressLine2")
                    }
                  />
                </div>
                <div className="input-field-placement">
                  <label className="lable-font">City</label>
                  <input
                    type="text"
                    placeholder="City"
                    className="field-styling"
                    required
                    value={!isChecked ? `${city}` : `${billingAddressCity}`}
                    onChange={(e) => handleChange(e, "billingAddressCity")}
                  />
                </div>
                {billingAddressCityError && inputError(billingAddressCityError)}
                <div className="state-zip-pacement">
                  <div className="input-field-placement">
                    <label className="lable-font">State</label>
                    <select
                      id="state"
                      name="state"
                      value={!isChecked ? `${state}` : `${billingAddressState}`}
                      onChange={handleChangeBillingState}
                      className="field-styling"
                    >
                      <option value="">Select a state</option>
                      {Object.entries(stateOptions).map(
                        ([abbreviation, fullName]) => (
                          <option key={abbreviation} value={abbreviation}>
                            {fullName}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div className="input-field-placement">
                    <label className="lable-font">Zip</label>
                    <input
                      type="text"
                      placeholder="Zip"
                      className="field-styling"
                      required
                      value={!isChecked ? `${zip}` : `${billingAddressZip}`}
                      onChange={(e) => handleChange(e, "billingAddressZip")}
                    />
                  </div>
                </div>
                {billingAddressStateError &&
                  inputError(billingAddressStateError)}
                {billingAddressZipError && inputError(billingAddressZipError)}
              </div>
            )}
          </div>
          <div>
            <h2 className="stripe-checkout-font">
              <img
                src={padlockIcon}
                style={{ width: "15px", height: "15px", marginRight: "5px" }}
              />
              Payment Method
            </h2>
            <p className="transaction-line">
              All transactions are secure and encrypted.
            </p>
            <div className="account-detail-container">
              <div className="input-field-placement">
                <label
                  className="stripe-card-fields lable-font"
                  style={{ lineHeight: "18px" }}
                >
                  Card number
                  <div style={{ position: "relative" }}>
                    <CardNumberElement
                      options={elementStyle}
                      className="stripe-input field-styling content-center"
                      onChange={handleCardNumberChange}
                    />
                    <img
                      src={creditCardIcon} // Replace with the path to your credit card icon
                      alt="Credit Card Icon"
                      style={{
                        position: "absolute",
                        right: "5px", // Adjust as needed
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: "73px", // Adjust size as needed
                        height: "20px", // Adjust size as needed
                        cursor: "pointer", // Adjust size as needed
                      }}
                      className="credit-card-icon"
                    />
                  </div>
                </label>
              </div>
              <div className="state-zip-pacement">
                <label
                  className="stripe-card-fields lable-font"
                  style={{ lineHeight: "18px" }}
                >
                  Expiration date
                  <CardExpiryElement
                    options={elementStyle}
                    className="stripe-input field-styling content-center box-width"
                    onChange={handleCardExpiryChange}
                  />
                </label>
                <div
                  className="input-field-placement"
                  style={{ position: "relative" }}
                >
                  <label
                    className="stripe-card-fields lable-font"
                    style={{ lineHeight: "18px" }}
                  >
                    Security code
                    <CardCvcElement
                      options={elementStyle}
                      className="stripe-input field-styling content-center box-width"
                      onChange={handleCardCvcChange}
                    />
                  </label>
                  {/* Image positioned to the right of the CVC input */}
                  <img src={cvcIcon} alt="CVC Info" className="cvc-icon" />
                </div>
              </div>
              <div className="state-zip-pacement">
                <label
                  className="stripe-card-fields lable-font"
                  style={{ lineHeight: "18px" }}
                >
                  Country
                  <select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    className="custom-input field-styling content-center box-width"
                  >
                    <option value="">Select Country</option>
                    <option value="US">United States</option>
                  </select>
                </label>

                <div
                  className="input-field-placement"
                  style={{ position: "relative" }}
                >
                  <label
                    className="stripe-card-fields lable-font"
                    style={{ lineHeight: "18px" }}
                  >
                    Postcode
                    <input
                      type="text"
                      value={postcode}
                      onChange={(e) => setPostcode(e.target.value)}
                      className="custom-input field-styling content-center box-width"
                      placeholder="Postcode"
                      maxLength={5}
                    />
                  </label>
                  {/* Image positioned to the right of the Postcode input */}
                  <img src={cvcIcon} alt="Postcode Info" className="cvc-icon" />
                </div>
              </div>
            </div>
            <div className="checkbox-row" style={{ marginTop: "15px" }}>
              <input
                type="checkbox"
                id="agree"
                checked={isCheckedTerms}
                onChange={(e) => setIsCheckedTerms(e.target.checked)}
                style={{ cursor: "pointer" }}
              />
              {/* without rel="noreferrer", it will cause security risk in older browsers*/}
              <label htmlFor="agree" className="agree-text">
                I AGREE TO THE{" "}
                <a
                  href="https://claya.com/terms-of-use/"
                  target="_blank"
                  rel="noreferrer"
                >
                  TERMS OF USE
                </a>
                ,{" "}
                <a
                  href="https://claya.com/privacy-policy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  PRIVACY POLICY
                </a>
                , AND{" "}
                <a
                  href="https://openloophealth.com/telehealth-consent/"
                  target="_blank"
                  rel="noreferrer"
                >
                  TELEHEALTH CONSENT
                </a>
                , TO COMPLETE THE INTAKE FORM AFTER THE PURCHASE.
              </label>
            </div>

            <div className="checkbox-row">
              <input
                type="checkbox"
                checked={isSubscribed}
                onChange={() => setIsSubscribed(!isSubscribed)}
                style={{ cursor: "pointer" }}
              />
              <label className="agree-text">
                By subscribing, you agree to receive Account Notification text
                messages at the phone number provided. Reply STOP to cancel.
                Message and data rates may apply.
              </label>
            </div>

            <button
              type="submit"
              className="pay-now-btn"
              disabled={
                !selectedPlan ||
                !isCheckedTerms ||
                !CardNumberElement ||
                !isCardValid ||
                disbaledBtn ||
                loading
              }
              style={{
                backgroundColor:
                  !selectedPlan ||
                  !isCheckedTerms ||
                  !CardNumberElement ||
                  disbaledBtn ||
                  !isCardValid ||
                  loading
                    ? "#d3d3d3"
                    : "#0c3972",
                cursor: loading ? "not-allowed" : "pointer",
                color:
                  !selectedPlan ||
                  !isCheckedTerms ||
                  !CardNumberElement ||
                  !isCardValid ||
                  disbaledBtn ||
                  loading
                    ? "white"
                    : "white",
              }}
            >
              <img
                src={lockIcon}
                alt="Lock Icon"
                style={{
                  marginRight: "6px",
                  verticalAlign: "middle",
                  width: "13px",
                  height: "15px",
                }}
              />
              {loading ? "Processing..." : "COMPLETE PURCHASE"}
            </button>
            <div className="btn-suffix">
              TRY IT RISK FREE! - LOSE 10% OF YOUR BODYWEIGHT OR YOUR MONEY BACK
            </div>

            {isPaymentErr && apiError(isPaymentErr)}
            {patientError && apiError(patientError)}
            {error && apiError(error)}
          </div>
        </div>
      </form>
    );
  };

  const handleBack = () => {};

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container  page-checkout-container">
        <div className="checkout-container">
          <div>
            <div className="payment-section">
              <Elements stripe={stripePromise}>
                <PaymentForm
                  totalPrice={totalPrice}
                  pricingData={pricingData}
                  couponDiscountValue={couponDiscountValue}
                  isCouponAppliedBox={isCouponAppliedBox}
                />
              </Elements>
            </div>
          </div>
          <div className="order-summary-box" style={{ marginBottom: "20px" }}>
            <h2 className="summary-font summary-font-box">Order Summary</h2>
            <div className="summary-box-content">
              <div className="first-layer first-layer-box">
                <img
                  src={
                    selectedType === "Injectable"
                      ? selectedMed === "Semaglutide"
                        ? SemaglutideBottle
                        : TirezepatideBottle
                      : selectedMed === "Semaglutide"
                      ? OralSemaglutideImg
                      : OralTirzepatideImg
                  }
                  alt={`${selectedType} - ${selectedMed}`}
                />
                <div className="separate-content-box">
                  <div className="med-placements-box">
                    <span className="med-info-text-box">{`${name}`}</span>{" "}
                    {/* Fallback to default name */}
                    {isCouponAppliedBox || isCouponAppliedBox ? (
                      <div className="med-info-price-box">
                        <span className="med-info-old-price">
                          {" "}
                          {(isCouponAppliedBox || isCouponAppliedBox) &&
                            (pricingData && pricingData[0]
                              ? `$${Math.floor(
                                  pricingData[0]?.unit_amount / 100
                                )}`
                              : "")}
                        </span>
                        <span className="med-info-new-price">
                          {pricingData && pricingData[0]
                            ? `$${Math.floor(
                                pricingData[0]?.unit_amount / 100 -
                                  (couponDiscountValue || 0)
                              )}`
                            : ""}
                          /mo
                        </span>
                      </div>
                    ) : (
                      <span className="med-info-new-price">
                        {pricingData && pricingData[0]
                          ? `$${Math.floor(
                              pricingData[0]?.unit_amount / 100 -
                                (couponDiscountValue || 0)
                            )}`
                          : ""}
                        /mo
                      </span>
                    )}
                  </div>
                  <div>
                    <span className="med-info-new-price">
                      $
                      {totalPrice.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                </div>
              </div>
              <Divider />

              <div
                className="coupon-container-toggle"
                style={{
                  borderTop: "1px solid rgba(220, 220, 220, 1)",
                  padding: "20px 0px",
                  borderBottom: "1px solid rgba(220, 220, 220, 1)",
                }}
              >
                {/* Toggle Header */}
                <div
                  className="coupon-toggle-header coupon-toggle-header-box"
                  onClick={toggleCouponInput}
                >
                  <span className="other-coupon-box">
                    Do you have a coupon code?
                  </span>
                  <span
                    className={`coupon-arrow-icons ${
                      showCouponInput ? "down-arrow" : "up-arrow"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                    >
                      <path
                        d="M0.84 6.41L6.5 0.75L12.16 6.41L11.45 7.11L6.5 2.16L1.55 7.11L0.84 6.41Z"
                        fill="black"
                      ></path>
                    </svg>
                  </span>
                </div>

                {/* Default Applied Coupon */}
                {isCouponAppliedBox && showCouponInput && (
                  <div className="coupon-container coupon-container-box">
                    <div className="coupon-container-text">
                      <img
                        src={TickIcon}
                        alt="TickIcon"
                        width="20px"
                        height="20px"
                      />
                      <p>
                        <span>100CLAYA</span> Applied. Congrats! You get $100
                        off
                      </p>
                    </div>
                    <button
                      className="coupon-remove-btn"
                      onClick={removeCoupon}
                    >
                      &times;
                    </button>
                  </div>
                )}

                {/* Input + Suggestion */}
                <div
                  className="coupon-input-wrapper-box"
                  style={{
                    display:
                      showCouponInput && !isCouponAppliedBox ? "block" : "none",
                  }}
                >
                  <div className="coupon-input-wrapper">
                    <input
                      type="text"
                      ref={couponInputRef}
                      value={couponCode}
                      onChange={handleCouponCodeChange}
                      placeholder="Enter your coupon code"
                      className="coupon-input-with-btn"
                    />
                    <button
                      disabled={loading1 || showDiscountlabel}
                      type="button"
                      onClick={() => applyCoupon()}
                      className="apply-btn-inside-input"
                    >
                      {showDiscountlabel ? "Applied" : "Apply"}
                    </button>
                  </div>

                  {showDiscountlabel && (
                    <div className="applied-coupon">
                      <img
                        src={couponImage}
                        alt="Coupon Icon"
                        style={{ width: "13px", height: "12.48px" }}
                      />
                      <span style={{ fontSize: "12px" }}>Coupon Applied</span>
                      <button
                        type="button"
                        onClick={removeCoupon}
                        className="remove-coupon-btn"
                      >
                        X
                      </button>
                    </div>
                  )}

                  {/* Default Coupon Suggestion */}
                  <div
                    className="coupon-container coupon-container-box"
                    style={{ cursor: "pointer" }}
                  >
                    <div className="coupon-container-text">
                      <img
                        src={CouponBadgeicon}
                        alt="CouponBadgeicon"
                        width="47px"
                        height="35px"
                      />
                      <p>
                        Save <span>$100</span> with <span>100CLAYA</span>
                      </p>
                    </div>
                    <div
                      className="coupon-apply couple-apply-box"
                      onClick={() => applyCoupon(defaultCouponCode)}
                    >
                      Apply
                    </div>
                  </div>
                </div>
                {wrongCoupon && (
                  <p className="error-message" style={{ textAlign: "left" }}>
                    Invalid coupon code. Please try again.
                  </p>
                )}
              </div>
              <div className="third-layer" style={{ alignItems: "flex-end" }}>
                <span
                  className="per-month-styling-box"
                  style={{ textAlign: "left" }}
                >
                  Total
                </span>
                <div className="price-display">
                  <span className="per-month-styling-box per-month-box">
                    $
                    {totalPrice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="weight-loss-checkout-msg-text">
            <img
              src={MoneyBackIcon}
              alt="MoneyBackIcon"
              style={{ height: "136px" }}
            />
            <span className="ellipse-font ellipse-font-box">
              Weight-loss guarantee:{" "}
              <span>
                lose at least 10% of your bodyweight in 120 days, or your money
                back!
              </span>
            </span>
          </div>
          <div className="badge-logos-box">
            <img src={UsIcon} alt="UsIcon" width={"69px"} height={"46px"} />
            <img
              src={HippaCompaliantIcon}
              alt="HippaCompaliantIcon"
              width={"124px"}
              height={"93px"}
            />
            <img
              src={LegitScripticon}
              alt="LegitScripticon"
              width={"94px"}
              height={"29px"}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <a href="#" onClick={openSiteLock}>
              <img
                className="img-fluid"
                alt="SiteLock"
                title="SiteLock"
                src="https://shield.sitelock.com/shield/claya.com"
              />
            </a>
          </div>

          <div className="help-box">
            <div className="help-text-ele">
              <h2 className="help-font">Need Help?</h2>
              <div className="adjust-dot-text">
                <div className="dot">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <circle cx="9" cy="9.63965" r="6" fill="#00B57A" />
                    <circle
                      cx="9"
                      cy="9.63965"
                      r="7.5"
                      stroke="#00B57A"
                      strokeOpacity="0.15"
                      strokeWidth="3"
                    />
                  </svg>
                </div>
                <span className="available-text">
                  Available{" "}
                  <span className="available-timings">8 AM – 8 PM ET</span>
                </span>
              </div>
            </div>
            <div className="contact-ele">
              <div className="phone-img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1419_1009)">
                    <path
                      d="M8.20312 0.139821C11.9561 0.139821 15 3.18377 15 6.93669C15 7.32634 14.6865 7.63982 14.2969 7.63982C13.9072 7.63982 13.5938 7.32634 13.5938 6.93669C13.5938 3.96013 11.1797 1.54607 8.20312 1.54607C7.81348 1.54607 7.5 1.23259 7.5 0.842946C7.5 0.453297 7.81348 0.139821 8.20312 0.139821ZM8.4375 5.76482C8.95518 5.76482 9.375 6.18464 9.375 6.70232C9.375 7.22 8.95518 7.63982 8.4375 7.63982C7.91982 7.63982 7.5 7.22 7.5 6.70232C7.5 6.18464 7.91982 5.76482 8.4375 5.76482ZM7.5 3.65544C7.5 3.2658 7.81348 2.95232 8.20312 2.95232C10.4033 2.95232 12.1875 4.7365 12.1875 6.93669C12.1875 7.32634 11.874 7.63982 11.4844 7.63982C11.0947 7.63982 10.7812 7.32634 10.7812 6.93669C10.7812 5.51287 9.62695 4.35857 8.20312 4.35857C7.81348 4.35857 7.5 4.04509 7.5 3.65544ZM3.44238 0.180836C4.01074 0.0255629 4.60547 0.315602 4.83105 0.860524L6.00293 3.67302C6.20215 4.15056 6.06445 4.70427 5.66309 5.02947L4.21875 6.21306C5.19434 8.27556 6.86426 9.94548 8.92676 10.9211L10.1074 9.47673C10.4355 9.07537 10.9863 8.93767 11.4639 9.13689L14.2764 10.3088C14.8213 10.5343 15.1113 11.1291 14.9561 11.6974L14.2529 14.2756C14.1152 14.7853 13.6523 15.1398 13.125 15.1398C5.87695 15.1398 0 9.26287 0 2.01482C0 1.48748 0.354492 1.02459 0.864258 0.883961L3.44238 0.180836Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1419_1009">
                      <rect
                        width="15"
                        height="15.0006"
                        fill="white"
                        transform="translate(0 0.139404)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h2 className="phone-number">+1 (415) 980-4031</h2>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CheckoutSignupPage2;
